<span
    class="badge badge-cliente-carteira-tipo badge-cliente-carteira-tipo-projetada"
    [ngClass]="{'pipeline-card-title-badge': isPipelineCardTitleBadge}"
    [title]="tipo.nome">
    {{tipo.abreviacao}}
</span>